interface SummaryData {
  count: number;
  totalAmount: number;
  taxAmount: number;
  grandTotal: number;
}

interface DataSummaryProps {
  summary: SummaryData;
}

export function DataSummary({ summary }: DataSummaryProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 rounded-lg border bg-white p-4 dark:bg-zinc-950">
      <div>
        <p className="text-xs text-zinc-500">记录总数</p>
        <p className="text-lg font-semibold">{summary.count.toLocaleString()}</p>
      </div>
      <div>
        <p className="text-xs text-zinc-500">金额合计</p>
        <p className="text-lg font-semibold">
          ¥{Number(summary.totalAmount).toLocaleString("zh-CN", { minimumFractionDigits: 2 })}
        </p>
      </div>
      <div>
        <p className="text-xs text-zinc-500">税额合计</p>
        <p className="text-lg font-semibold">
          ¥{Number(summary.taxAmount).toLocaleString("zh-CN", { minimumFractionDigits: 2 })}
        </p>
      </div>
      <div>
        <p className="text-xs text-zinc-500">总金额合计</p>
        <p className="text-lg font-semibold">
          ¥{Number(summary.grandTotal).toLocaleString("zh-CN", { minimumFractionDigits: 2 })}
        </p>
      </div>
    </div>
  );
}